import axios from "axios";
import io from "socket.io-client";
const socket = io(`${process.env.REACT_APP_CHAT_SERVER}`);

export const SET_CONVO = "SET_CONVO";
export const UPDATE_CONVO_MESSAGES = "UPDATE_CONVO_MESSAGES";
export const UPDATE_CONVO_STATUS = "UPDATE_CONVO_STATUS";

export const setConvo = (convo) => ({
  type: SET_CONVO,
  payload: convo,
});

export const updateMessage = (message) => ({
  type: UPDATE_CONVO_MESSAGES,
  message: message,
});

export const updateStatus = (status) => ({
  type: UPDATE_CONVO_STATUS,
  status: status,
});

export const createConvo = (widgetConfigs) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_CHAT_MICROSERVICE_URL}/tickets/create`,
      {
        uniquePartnerId: widgetConfigs.uniquePartnerId,
        name: "",
        number: "",
        email: "",
        subject: "",
        category: "",
        status: "assigned",
        source: "widget",
        subSource: "convo",
        type: "inbox",
        priority: "medium",
        description: "",
        cc: [{ name: "", address: "" }],
      }
    );

    try {
      const roomId = `Room-${new Date().getTime()}`;
      const customerId = null;
      const uniquePartnerId = widgetConfigs.uniquePartnerId;
      socket.emit(
        "createRoom",
        uniquePartnerId,
        roomId,
        response.data._id,
        customerId,
        (response) => {
          if (response.success) {
            dispatch(setConvo(response.conversation));
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  } catch (error) {
    console.error("Error occurred while creating convo", error);
  }
};

export const updateConvoMessage = (message) => async (dispatch) => {
  if (message) {
    dispatch(updateMessage(message));
  } else {
    console.log("message missing!");
  }
};

export const updateConvoStatus = (status) => async (dispatch) => {
  if (status) {
    dispatch(updateStatus(status));
  } else {
    console.log("status missing!");
  }
};
